import type { ButtonStyles } from '@net0-calc/common/components/ui/Button/styles';

export const monacoButtonStyles: ButtonStyles = {
  primary: isLoading => `
    color: var(--color6);
    border: 1px solid var(--color2);
    background-color: var(--color5);
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--color8);
      border-color: var(--color1);
    }

    ${
      !isLoading
        ? `
    &:disabled {
      color: var(--color7);
      border-color: var(--color10);
      background-color: var(--color8);
    }
    `
        : ''
    }
  `,
  secondary: isLoading => `
    color: var(--color6);
    border: 1px solid var(--color10);
    background-color: var(--color5);
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--color2);
      background-color: var(--color14);
      color: var(--color2);
    }

    ${
      !isLoading
        ? `
    &:disabled {
      color: var(--color7);
      border: 1px solid var(--color10);
      background-color: var(--color8);
    }
    `
        : ''
    }
  `,
  ternary: () => `
    color: var(--color9);
    border: 1px solid var(--color10);
    background-color: transparent;
    transition: all 0.2s ease;

    &:hover {
      color: var(--color6);
      border-color: var(--color9);
    }

    &:disabled {
      color: var(--color7);
    }
  `,
};
